module.exports = __webpack_public_path__ + "static/3.1-Clipboard_Icon-01-37c469f71dfaba0e78dcb7a268cd884d.png";